<template>
  <a-layout style="height: 100vh">
    <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible width="155" class="left-aside">
      <VabLogo :collapsed="collapsed"></VabLogo>
      <a-menu theme="dark" mode="inline" v-model:selectedKeys="selectedKeys" :open-keys="openKeys">
        <VabMenu v-for="route in routes" :key="route.path" :item="route"></VabMenu>
      </a-menu>
    </a-layout-sider>
    <a-layout style="background: #fff">
      <VabHeader :collapsed="collapsed" @ToggleCollapse="ToggleCollapse"></VabHeader>
      <VabContent></VabContent>
    </a-layout>
  </a-layout>
  <Advertisement2 ref="Advertisement2" />
</template>
<script>
import VabLogo from "./vab-logo/index"
import VabContent from "./vab-content/index"
import VabMenu from "./vab-menu/index"
import VabHeader from "./vab-header/index"
import Advertisement2 from "@/views/base/components/advertisement2"
export default {
  components: {
    VabLogo,
    Advertisement2,
    VabContent,
    VabMenu,
    VabHeader,
  },
  data() {
    return {
      collapsed: false,
      selectedKeys: [],
      routes: [],
    }
  },
  methods: {
    ToggleCollapse() {
      this.collapsed = !this.collapsed
    },
  },
  watch: {
    $route: {
      handler({ path, matched }) {
        matched[0].children.length > 1 ? (this.selectedKeys = [path]) : (this.selectedKeys = [matched[0].path])
        var routes = this.$router.options.routes
        this.routes = routes.filter((item) => {
          return item.children && !item.hidden
        })
        this.openKeys = ["/select_goods"]
      },
      immediate: true,
    },
  },
}
</script>
<style lang="less" scoped>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}
.site-layout .site-layout-background {
  background: #fff;
}
.left-aside {
  height: 100vh;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgb(241, 241, 241);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(193, 193, 193);
    border-radius: 10px;
  }
}
</style>
